import { render } from "./ProfilePhotoComponent.vue?vue&type=template&id=8eb437f4&ts=true"
import script from "./ProfilePhotoComponent.vue?vue&type=script&lang=ts"
export * from "./ProfilePhotoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__